import React from 'react';

import { PaymentCheckout } from '../../components/Payment';

const PaymentCheckoutView: React.FC = () => {
  return <PaymentCheckout />;
};

export default PaymentCheckoutView;

